import { getAuthToken } from "lib/api";

export function isAuthenticated() {
  return Boolean(getAuthToken());
}
